import { render, staticRenderFns } from "./AuditDialog.vue?vue&type=template&id=49c90070&scoped=true"
import script from "./AuditDialog.vue?vue&type=script&lang=js"
export * from "./AuditDialog.vue?vue&type=script&lang=js"
import style0 from "./AuditDialog.vue?vue&type=style&index=0&id=49c90070&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c90070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/chaoangoods.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c90070')) {
      api.createRecord('49c90070', component.options)
    } else {
      api.reload('49c90070', component.options)
    }
    module.hot.accept("./AuditDialog.vue?vue&type=template&id=49c90070&scoped=true", function () {
      api.rerender('49c90070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inquiryCenter/AuditDialog.vue"
export default component.exports